import mongoose from "mongoose";

export enum UserRoleInOrganization {
    Administration = "Administration",
    BusinessDevelopment = "Business Development",
    Educator = "Educator",
    Engineer = "Engineer",
    Marketing = "Marketing",
    Media = "Media",
    Military = "Military/Government",
    ProgramManager = "Program Manager",
    Scientist = "Scientist",
    Othe = "Other",
}

export enum QuiltyUserRoleInOrganization {
    Executive = "Executive",
    InvestmentBanking = "Investment Banking",
    PrivateEquity = "Private Equity",
    VentureCapital = "Venture Capital",
    Consulting = "Consulting",
    CorporateStrategy = "Corporate Strategy",
    Research = "Competitive Intelligence & Market Research",
    Other = "Other Professional",
    Student = "Student",
}

export enum UserRole {
    Generic = "generic",
    Admin = "admin",
    Assistant = "assistant",
    ThirdpartyAdmin = "thirdpartyAdmin",
}

export enum UserAffiliation {
    Student = "student",
    Educator = "educator",
    CommercialDeveloper = "commercial developer",
    CommercialOperator = "commercial operator",
    CommercialServices = "commercial services",
    Insurance = "insurance",
    Legal = "legal",
    Policy = "policy",
    Government = "government",
    Academia = "academia",
    ResearchLab = "research lab",
    MarketResearch = "market research",
    FinancialsInvestment = "financials & investment",
    Hobbyist = "hobbyist",
    Other = "other",
}

export enum UserStatus {
    Blocked = "blocked",
    Ok = "ok",
}

export enum Gender {
    Male = "male",
    Female = "female",
    Other = "other",
}

export enum IndustrySegment {
    CommericalSpace = "Commerical Space",
    Government = "Government",
    FinanceInvestment = "Finance & Investment",
    Academia = "Academia",
    Other = "Other",
}

export interface AnalyticFilter {
    logicalOperator: "AND" | "OR";
    products: string[];
    services: string[];
    countries: string[];
    operatingRegimeTags: string[];
    applicationTags: string[];
}

export interface Analytic {
    analyticId: string;
    analyticFilter: AnalyticFilter;
}

export interface License {
    firstName: string;
    lastName: string;
    email: string;
    status: string;
}

export interface User {
    affiliation: UserAffiliation;
    citizenship: string;
    city: string;
    cookiesAccepted?: boolean;
    contractId?: string;
    organizationId?: mongoose.Types.ObjectId;
    organizationName?: string;
    organizationSearchTracker?: {
        date: string;
        count: number;
        organizationIds: string[];
    };
    country: string;
    dateOfBirth?: Date;
    downloadedReports?: Array<{
        date: Date;
        reportId: string;
    }>;
    email: string;
    expertise?: string;
    favorites?: {
        conferenceIds?: string[];
        organizationIds?: string[];
        analytics?: Analytic[];
    };
    firstName: string;
    industrySegment: IndustrySegment;
    lastName: string;
    licenses?: License[];
    newsletterEmail: boolean;
    password: string;
    phone: string;
    pictureProfile?: string;
    professionalInterests?: string;
    quiltyMarketMonitorEmails: boolean;
    quiltyNewsletterEmails: boolean;
    quiltyReportNotificaitonEmails: boolean;
    referredBy?: string;
    registrationDate: Date;
    role: UserRole;
    roleInOrganization?: UserRoleInOrganization | QuiltyUserRoleInOrganization;
    sex?: Gender;
    spaceSymposiumPicture?: string;
    state: string;
    status: UserStatus;
    streetAddress: string;
    stripeId?: string;
    termsAccepted?: boolean;
    userid: string;
    zipcode: string;
}

export const userRepresentationKeys = ["userid", "firstName", "lastName"] as const;
export type UserRepresentation = Pick<User, typeof userRepresentationKeys[number]>;
